import React, {
    useEffect, useState
} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Layout from '../../components/core/layout';
import {
    Box, TextField, Typography
} from '@mui/material';
import {
    Data, post
} from '../../networking';
import TrackingScripts from '../../sections/trackingScripts';
import Link from 'next/link';
import {
    useRouter
} from 'next/router';
import SunnysidePineLogo from '../../../public/icons/sunnyside/sunnyside-logo-pine';
import SunnysideButton from '../../components_sunnyside/button';
import {
    colors
} from '../../styles/_colors';

async function postAuthLoginEmailRequest(payload: Data): Promise<Data> {
    return await post('auth/login/email/request', payload);
}

async function postLogout(): Promise<Data> {
    return post('auth/logout', {});
}

const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
}));

export default function LoginEmail(): JSX.Element {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const classes = useStyles();
    const router = useRouter();

    useEffect(() => {
        postLogout();
        if (router.query.email) {
            setEmail(router.query.email as string);
        }
    }, []);

    const handleEmailChange = (ev) => {
        setEmail(ev.target.value);
        setError('');
    };

    const handleInputKeyPress = (ev) => {
        // Enter
        if (ev.key === 'Enter' || ev.keyCode === 13) {
            handleSubmit();
        }
    };

    const handleSubmit = () => {
        postAuthLoginEmailRequest({
            email
        }).then((response) => {
            if (!response.message) {
                router.push({
                    pathname: '/login/email-check',
                    query: {
                        email
                    }
                });
            } else {
                setError(response.message as string);
            }
        });
    };

    return (
        <>
            <TrackingScripts />
            <Layout>
                <Box
                    p="2em"
                    className={classes.wrapper}
                >
                    <Box>
                        <Box mb="2em">
                            <SunnysidePineLogo
                                width="125"
                                height="48"
                            />
                        </Box>
                        <Typography
                            variant="h5"
                            color="black"
                        >
                            Securely Log In
                        </Typography>
                        <Box mt="1rem">
                            <Typography>
                                Enter your
                                {' '}
                                <strong>
                                    email address
                                </strong>
                                {' '}
                                below to access your Sunnyside account.
                            </Typography>

                        </Box>
                        <Box>
                            <TextField
                                error={!!error}
                                helperText={error}
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Your email"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                onChange={(ev) => handleEmailChange(ev)}
                                onKeyPress={handleInputKeyPress}
                                value={email}
                            />
                            <Box
                                my={2}
                                mt='1rem'
                            >
                                <SunnysideButton
                                    className="button-fixed-width"
                                    style={{
                                        borderRadius: '10px'
                                    }}
                                    onClick={handleSubmit}
                                >
                                    Continue
                                </SunnysideButton>
                            </Box>
                        </Box>
                        <Box
                            mt=".5em"
                            mb='2.5rem'
                        >
                            <SunnysideButton
                                className="button-fixed-width"
                                bgcolor={colors.cloud}
                                textcolor={colors.sky}
                                style={{
                                    borderRadius: '10px',
                                    border: `solid 2px ${colors.sky}`
                                }}
                                url='/login/phone'
                            >
                                Log in with phone
                            </SunnysideButton>
                        </Box>
                    </Box>
                    <Box my={3}>
                        <Typography>
                            Don&apos;t have an account?
                        </Typography>
                        <Box mt=".3rem">
                            <Link href="/landing">
                                <a>
                                    Start your free trial
                                    <img
                                        src={'/img/btn-arrow-right-primary.png'}
                                        srcSet={'/img/btn-arrow-right-primary@2x.png 2x, /img/btn-arrow-right-primary@3x.png 3x'}
                                    />
                                </a>
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Layout>
        </>
    );
}
